import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Event } from "../../../Models/Event";
import { useStore } from "../../../Stores/store";
import { ContentType } from "../../../Enumerators/ContentType";
import { Formik } from "formik";
import { observer } from 'mobx-react-lite';

const inputClass = "w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500";
const labelClass = "text-sm font-medium text-gray-700";

export default observer(function EventForm() {

  const { generalStore } = useStore();
  const { selectedEvent, addUpdateEvent } = generalStore;
  const apiKey: string | undefined = process.env.REACT_APP_TINY_MCE_KEY;
  const formVals : Event = selectedEvent ?? {
    id: 0,
    date: "",
    title: "",
    content: "",
    price: 0,
    type: ContentType.event
  }

  const handleSubmit = (values : any) => {
    addUpdateEvent(values);
  }

  return (
    <Formik
    initialValues={formVals}
    onSubmit={(values) => handleSubmit(values)}
    enableReinitialize
    >
    {({handleSubmit, handleChange, values}) => (
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <label htmlFor="title" className={labelClass}>Event Title</label>
          <input type="text" name="title" id="title" value={values.title} onChange={handleChange} className={inputClass} />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="date" className={labelClass}>Date</label>
          <input type="datetime-local" name="date" id="date" value={values.date} onChange={handleChange} className={inputClass} />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="content" className={labelClass}>Description</label>
          <Editor
            apiKey={apiKey}
            initialValue="<p>Event...</p>"
            init={{
              height: 300,
              menubar: false,
              plugins: [
                "advlist autolink lists link image",
                "charmap print preview anchor help",
                "searchreplace visualblocks code",
                "insertdatetime media table paste wordcount",
              ],
              toolbar:
                "undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | help",
            }}
            onChange={handleChange}
            onEditorChange={(e) => {
              handleChange({target: {name: "content", value: e}})
            }}
            value={values.content}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="price" className={labelClass}>Price</label>
          <input type="number" id="price" name="price" value={values.price} onChange={handleChange} className={inputClass} />
        </div>
        <input type="hidden" id="id" name="id" value={values.id} />
        <button type="submit" className="w-full mt-2 bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition-colors text-sm font-medium cursor-pointer">Submit Event</button>
      </form>
    )}
    </Formik>
  );
});
